import React from 'react';
import { Button, FormControl, Grid } from '@mui/material';

import { FormattedMessage } from 'react-intl';
import LanguageUtils from '../../../utils/LanguageUtils';
import GenericTextField from '../../common/widgets/genericTextField';
import ReportHeader005Filters from '../../../interfaces/filters/reportHeader005Filters';
// import { DatePicker } from '@mui/lab';
interface IFilterProps {
    filters: ReportHeader005Filters;
    onChange: any;
    applyFilters: any;
    setDefaultState: any;
}

const messages = {
    invoiceYear: LanguageUtils.createMessage('Invoice year'),
    invoiceMonth: LanguageUtils.createMessage('Invoice month'),
    resetFilters: LanguageUtils.createMessage('Reset filters'),
    applyFilters: LanguageUtils.createMessage('Apply filters')
};

export default function ReportHeader005FilterComponent(props: IFilterProps): JSX.Element {
    const { filters, onChange, applyFilters, setDefaultState } = props;

    // const dispatch = useDispatch();
    // const { formatMessage } = useIntl();

    // useEffect(() => {
    //     // dispatch(fetchProductArenaTypes({ paging }));
    //     dispatch(fetchUnitGroups({ paging }));
    //     dispatch(fetchCurrencies({ paging }));
    //     dispatch(fetchOUSPStatuses({ paging }));
    // }, [dispatch]);

    return (
        <Grid container p={2} direction="column">
            <Grid item>
                <Grid container spacing={2} mt={1} alignItems="flex-end">
                    <Grid item xs>
                        <FormControl fullWidth>
                            <GenericTextField<number>
                                name="invoiceYear"
                                label={messages.invoiceYear}
                                onChange={onChange}
                                value={filters.invoiceYear}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs>
                        <FormControl fullWidth>
                            <GenericTextField<number>
                                name="invoiceMonth"
                                label={messages.invoiceMonth}
                                onChange={onChange}
                                value={filters.invoiceMonth}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Grid container spacing={2} mt={1} justifyContent="flex-end">
                    <Grid item>
                        <Button onClick={setDefaultState}><FormattedMessage {...messages.resetFilters} /></Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={applyFilters}><FormattedMessage {...messages.applyFilters} /></Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}